// extracted by mini-css-extract-plugin
export default {"root":"TITmP","text":"x3EnS","short":"_vOiH","more":"kIrw8","moreButton":"Ekyia"};